/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(群馬グリーン)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForGgr',
  data: () => ({
  }),
  computed: {
  },
  methods: {
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)

      if (Number(x) === this.computedColNumList.haishaKbnNm) {
        console.log('change After :', this.computedColNumList.jidoshaHyojiNm, this.computedColNumList.hacchusakiNm)
        // 配車先毎入力制御
        if (newValue === '自社') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, false)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, true)
        } else if (newValue === '傭車') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, true)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, false)
        }
      }
      // 主たる乗務員をセットする
      if (Number(x) === this.computedColNumList.jidoshaHyojiNm) {
        const target = filter.dateFormatter(new Date())

        const sharyoInfo = this.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((elem) => {
          return elem.kaishaCd === this.currentKaishaCode && elem.jidoshaHyojiNm === newValue && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })

        if (sharyoInfo.length > 0) {
          const targetJomuinCd = sharyoInfo[0].jomuinCd
          if (![undefined, null, ''].includes(targetJomuinCd)) {
            const targetJomuin = this.eigyoshoJininList.map((elem) => {
              elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
              elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
              return elem
            }).filter((elem) => {
              return elem.kaishaCd === this.currentKaishaCode && elem.jininCd === targetJomuinCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
            })
            if (targetJomuin.length > 0) {
              const cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.jininNm1, y)
              this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, targetJomuin[0].jininNmSei, true)
            }
          }
        }
      }
      /*
        請求金額自動計算
       */
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const t = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.codeNm === this.rows[y].unchinKeisanKbnNm)
        const tUnchinKeisanKbn = t ? t.code : '03'
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''

        if (Number(x) === this.computedColNumList.juchuSuryo) {
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.juchuJuryo) {
          this.calcKihonUnchinByWeight(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.unchinKeisanKbnNm) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
        if (Number(x) === this.computedColNumList.tanka) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
      }
      // 品名マスタ情報設定
      if (Number(x) === this.computedColNumList.hinmeiNm) {
        const target = filter.dateFormatter(new Date())

        const hinmeiInfo = this.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((elem) => {
          return elem.kaishaCd === this.currentKaishaCode && elem.hinmeiNm === newValue && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })

        if (hinmeiInfo.length > 0) {
          const tankaCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.tanka, y)
          this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(tankaCell, hinmeiInfo[0].tanka, true)

          const targetUnitKbnCd = hinmeiInfo[0].unitKbn
          if (![undefined, null, ''].includes(targetUnitKbnCd)) {
            const targetSbtList = this.shubetsuList.filter(elem => {
              return elem.kaishaCd === this.currentKaishaCode && elem.sbtCd === targetUnitKbnCd && elem.sbtShuruiCd === 'SVI001'
            })
            if (targetSbtList.length > 0) {
              const unitCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.unitKbnNm, y)
              this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(unitCell, targetSbtList[0].sbtNm, true)
            }
          }

          const targetSuryoJuryoKbnCd = hinmeiInfo[0].unchinKeisanKbn
          if (![undefined, null, ''].includes(targetSuryoJuryoKbnCd)) {
            const targetKbnList = this.kubunList.filter(elem => {
              return elem.kaishaCd === this.currentKaishaCode && elem.code === targetSuryoJuryoKbnCd && elem.kbnShuruiCd === 'SFF055'
            })
            if (targetKbnList.length > 0) {
              const SuryoJuryoCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.unchinKeisanKbnNm, y)
              this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(SuryoJuryoCell, targetKbnList[0].codeNm, true)
            }
          }
        }
      }
    }
  }
}
